import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26cb0b86"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href"]

import { withDefaults, computed } from 'vue';
interface Props {
  iconClass: string;
  className?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'base-svg',
  props: {
    iconClass: {},
    className: {}
  },
  setup(__props: any) {

const props = __props;
const iconName = computed(() => {
  return `#icon-${props.iconClass}`;
});
const svgClass = computed(() => {
  if (props.className) {
    return 'svg-icon ' + props.className;
  } else {
    return 'svg-icon';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(svgClass.value),
    "aria-hidden": "true"
  }, [
    _createElementVNode("use", { "xlink:href": iconName.value }, null, 8, _hoisted_1)
  ], 2))
}
}

})